import React from 'react';
import { TextField, Box, Typography, InputAdornment } from '@mui/material';
import styles from './index.module.css';

const CustomTextField = ({
    label,
    value,
    handleChange,
    name,
    placeholder,
    error,
    helperText,
    disabled,
    readOnly,
    isRequired,
    isMarginField,
    pricing,
    handleBlur,
    iconClick,
    icon,
    border,
    multiline = false,
    minRows,
    maxRows,
    multilineRootClassName,
    multilineInputClassName,
    type,
    InputProps: externalInputProps,
    formatDisplayValue,
    onFocus: externalOnFocus,
    onBlur: externalOnBlur,
    ...rest
}) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const hasDisplayFormatter = typeof formatDisplayValue === 'function';
    const displayedValue = !isFocused && hasDisplayFormatter
        ? formatDisplayValue(value)
        : value;
    const inputClassName = [styles.zeroPaddingInput, multiline && multilineInputClassName]
        .filter(Boolean)
        .join(' ');
    const inputRootClassName = [externalInputProps?.className, multiline && multilineRootClassName]
        .filter(Boolean)
        .join(' ');

    const inputProps = {
        ...(multiline ? {} : {
            inputMode: 'decimal',
            pattern: '[0-9]*[.,]?[0-9]*',
        }),
        startAdornment: pricing && !isMarginField ? (
            <InputAdornment position="start">$</InputAdornment>
        ) : null,
        endAdornment: icon ? icon : isMarginField && pricing ? (
            <InputAdornment position="end">%</InputAdornment>
        ) : null,
        style: pricing && isMarginField ? { textAlign: 'right' } : undefined,
        classes: {
            ...externalInputProps?.classes,
            input: inputClassName,
        }
    };

    return (
        <Box className={styles.textFieldWrapper}>
            {label && (
                <Typography className={styles.label} variant="subtitle1" gutterBottom>
                    {label}  <span className={styles.requiredSymbol}>{isRequired ? '*' : ''}</span>
                </Typography>
            )}
            <TextField
                className={`${styles.textField} ${error ? styles.error : ''} ${pricing ? styles.pricing : ''} ${border ? styles.pricing : ''}`}
                value={displayedValue}
                onFocus={hasDisplayFormatter || externalOnFocus ? (event) => {
                    if (hasDisplayFormatter) setIsFocused(true);
                    externalOnFocus?.(event);
                } : undefined}
                onChange={(event) => handleChange(event, name)}
                name={name}
                placeholder={placeholder}
                error={error}
                type={type}
                multiline={multiline}
                minRows={minRows}
                maxRows={maxRows}
                onBlur={hasDisplayFormatter || handleBlur || externalOnBlur ? (event) => {
                    if (hasDisplayFormatter) setIsFocused(false);
                    handleBlur?.(event);
                    externalOnBlur?.(event);
                } : undefined} FormHelperTextProps={{
                    sx: {
                        background: 'none !important',
                        color: error ? '#d32f2f' : 'inherit',
                        fontFamily: 'Nunito',
                        fontSize: '14px',
                        marginTop: '5px',
                        lineHeight: '2em',
                        // minHeight: '20px !important',
height: '40px',
                         '& .MuiInputBase-input': {
                            minWidth: '0px', // or 'auto', or a smaller pixel value
                            // minHeight: '0px', // or 'auto', or a smaller pixel value
                            padding: '8px',  // optional, to control height too
                        }
                    }
                }}
                helperText={
                    helperText ? (
                        <span className={styles.createOrderError}>{helperText}</span>
                    ) : null
                }
                fullWidth
                disabled={disabled}
                variant="outlined"
                {...rest}
                InputProps={{
                    ...externalInputProps,
                    ...inputProps,
                    className: inputRootClassName || undefined,
                    readOnly: Boolean(readOnly),
                    sx: readOnly ? {
                        backgroundColor: '#e2e6e9',
                        color: '#52606d',
                        '& .MuiInputBase-input': { cursor: 'default' },
                    } : undefined,
                    classes: {
                        ...externalInputProps?.classes,
                        input: inputClassName
                    }
                }}
            />
        </Box>
    );
};

export default CustomTextField;
